export enum StoreConnectionsTestIds {
  SECTION = 'store-home-connections',
  BRAND_CARD_PREFIX = 'store-home-connections-brand-',
  SEE_MORE = 'store-home-connections-see-more',
}
